import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { handleMessage } from 'broadcastChannels/deed';
import { reloadCurrentTabAction } from 'broadcastChannels/actions';

export const useBroadcastChannel = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    handleMessage('reloadAllTabs', () => dispatch(reloadCurrentTabAction()));
  }, []);
};
